export class StartupInfos_App_CluAgent {
    DEVICE_DISPLAY_CONNECTED: boolean;
    STD_PRINTERS: any[] = [];
    SPRINTERS: any[] = [];
    SDISPLAYS: any[] = [];
}

export class DbmCluAgentParams {
    ID: string;
    STD_PRINTER_ID?: string;
    STD_PRINTER_ORIENTATION?: PRINT_ORIENTATION;
    PRINTER_ID?: string;
    DISPLAY_ID?: string;
    CASH_BALANCE_ID?: string;
}

export enum PRINT_ORIENTATION {
    PORTRAIT = 1,
    LANDSCAPE = 2,
}

export const PRINT_ORIENTATION_LABELS: {[key: string]: string} = {
    '1': 'Portrait',
    '2': "Paysage",
}

export const PRINT_ORIENTATION_OPTIONS = [
    { mVALUE_MEMBER: PRINT_ORIENTATION.PORTRAIT, mDISPLAY_MEMBER: PRINT_ORIENTATION_LABELS[PRINT_ORIENTATION.PORTRAIT] },
    { mVALUE_MEMBER: PRINT_ORIENTATION.LANDSCAPE, mDISPLAY_MEMBER: PRINT_ORIENTATION_LABELS[PRINT_ORIENTATION.LANDSCAPE] },
];